"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 25",
    width: "21",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.5,25c-0.1,0-0.2,0-0.2-0.1C0.1,24.8,0,24.7,0,24.5v-24c0-0.2,0.1-0.3,0.3-0.4C0.4,0,0.6,0,0.8,0.1l20,12 c0.2,0.1,0.2,0.3,0.2,0.4s-0.1,0.3-0.2,0.4l-20,12C0.7,25,0.6,25,0.5,25z M1,1.4v22.2l18.5-11.1L1,1.4z"
  }));
};

exports["default"] = _default;